{
  "el": {
    "ai": {
      "settings": {
        "title": "Ρυθμίσεις AI",
        "description": "Διαμόρφωση για λειτουργίες AI στον χώρο εργασίας σου.",
        "budget": {
          "title": "Μηνιαίος προϋπολογισμός",
          "description": "Μηνιαίο ανώτατο όριο κόστους για τη χρήση AI (δοκιμαστική φάση). Επανυπολογίζεται με βάση τη χρήση tokens σε όλες τις συνομιλίες αυτόν τον μήνα.",
          "budget_label": "Προϋπολογισμός",
          "usage_label": "Χρήση αυτόν τον μήνα",
          "save": "Αποθήκευση"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "Όλα τα έργα",
        "empty_state": {
          "title": "Πώς μπορώ να σε βοηθήσω;",
          "subtitle": "Ρώτησέ με οτιδήποτε για τους πελάτες σου"
        },
        "suggestions": {
          "open_decisions": "Ποιες αποφάσεις είναι ακόμα ανοιχτές;",
          "unassigned_units": "Ποια ακίνητα δεν έχουν ακόμα πελάτη;",
          "help_notifications": "Πώς ρυθμίζω τις ειδοποιήσεις;",
          "help_project_settings": "Πού βρίσκω τις ρυθμίσεις έργου;"
        },
        "input": {
          "placeholder": "Ρώτησε για τους πελάτες σου...",
          "hint": "Enter για αποστολή · Shift+Enter για νέα γραμμή",
          "disclaimer": "Τα αποτελέσματα ενδέχεται να μην είναι ακριβή. Επαλήθευε πάντα τις σημαντικές πληροφορίες."
        },
        "errors": {
          "generic": "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
          "budget_reached": "Ο μηνιαίος προϋπολογισμός AI για αυτόν τον χώρο εργασίας έχει εξαντληθεί. Επικοινώνησε με έναν διαχειριστή για την αύξηση του ορίου."
        },
        "cap": {
          "message": "Έφτασες στο όριο συνομιλιών.",
          "action": "Έναρξη νέας συνομιλίας"
        },
        "history": {
          "title": "Προηγούμενες συνομιλίες",
          "empty": "Δεν υπάρχουν ακόμα προηγούμενες συνομιλίες"
        },
        "support_cta": {
          "prompt": "Δεν βρήκες την απάντηση που έψαχνες;",
          "action": "Επικοινωνία με την υποστήριξη"
        }
      }
    }
  }
}
